import { Typography, Box, } from "@mui/material"
import { memo, useEffect, useState } from "react";
import {
    getOwners,
    changeCode,
} from "../../api/index.js";
import Spinner from "../../components/Spinner.js";
import { useSnackbar } from "../../utils/index.js";
import Form from "../../components/Form.js";
import useSelectStyles from "../../components/styles/Select.js";


const ChangeOwnerCode = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);

    const { success, error } = useSnackbar();
    const classes = useSelectStyles();

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const { owners } = await getOwners();
            setFetchedOwners(owners);

            const dropdownValues = owners.map((owner) => ({
                value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`
            }));
            setOwnersDropdownValues(dropdownValues);
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const changeCodeFormContent = [
        {
            customType: "dropdown",
            id: "code",
            items: ownersDropdownValues,
            placeholder: "Επιλέξτε Εκτροφή",
            required: true,
        },
        {
            customType: "input",
            id: "newCode",
            type: "text",
            placeholder: "Νέος Κωδικός Εκτροφής",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ];

    const handleChangeCode = async (values) => {
        setIsLoading(true);
        const ownerId = fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.code)?._id;
        const { success: scs, message } = await changeCode(ownerId, values.newCode);
        if (scs) {
            success(message);
            window.location.reload();
        } else {
            error(message);
        }
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    <Typography variant="h5" sx={{ margin: "1rem" }}>
                        {"Επιλέξτε την Εκτροφή που σας ενδιαφέρει και εισάγετε τον νέο κωδικό"}
                    </Typography>
                    <Form
                        title="Επιλογή Εκτροφής"
                        content={changeCodeFormContent}
                        onSubmit={(values) => handleChangeCode(values)}
                        toResetForm={true}
                    />
                </Box>
            </Box>
        </>
    )
};

export default memo(ChangeOwnerCode);